//import React, {Component} from 'react';
import {BrowserRouter as Router} from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import Content from './Content';
import './styles/main.css';


function Main(){
    return(
      <Router>
        <Header/>
        <Content/>
        <Footer year={new Date().getFullYear()}/>
      </Router>
    );
  }

export default Main;
